import { Component, Input } from '@angular/core';
import { ModalService } from 'src/app/service/modal.service';

@Component({
  selector: 'app-modal-wrapper',
  templateUrl: './modal-wrapper.component.html',
  styleUrls: ['./modal-wrapper.component.scss']
})
export class ModalWrapperComponent {
  @Input() title: string = '';

  constructor(private modalService: ModalService) {}

  ngOnInit() {
    this.modalService.openModal();
  }
}
